import { COLORS } from '@shared/config/colors/colors';
import { Menu } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const DropdownHead = styled('div')<{ $isShowMenu: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    padding: 8px;
    transition: all 0.3s ease;
    background-color: ${({ $isShowMenu }) => ($isShowMenu ? COLORS.primary_60 : COLORS.neutral_05)};
    cursor: pointer;

    svg {
        transition: all 0.3s ease;
        color: ${({ $isShowMenu }) => ($isShowMenu ? COLORS.neutral_00 : COLORS.neutral_50)};
    }

    &:hover {
        background-color: ${({ $isShowMenu }) => ($isShowMenu ? COLORS.primary_60 : COLORS.neutral_10)};
    }

    &:active {
        background-color: ${({ $isShowMenu }) => ($isShowMenu ? COLORS.primary_60 : COLORS.primary_20)};
    }
`;

export const SearchWrapper = styled('div')`
    max-width: 328px;
    margin-left: auto;
`;

export const StyledMenu = styled(Menu)`
    width: auto !important;
`;

export const Fitlers = styled('div')`
    display: flex;
    width: 360px;
    flex-direction: column;
`;

export const FiltersHead = styled('div')`
    display: flex;
    padding: 12px 20px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${COLORS.neutral_10};
`;
